import script from "./CloheaLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CloheaLogo.vue?vue&type=script&setup=true&lang=ts"

import "./CloheaLogo.vue?vue&type=style&index=0&id=2c0bfc7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c0bfc7a"]])

export default __exports__